(() => {
  const sections = document.querySelectorAll('.lookbook-viewer');

  sections.forEach((section) => {
    const slides = Array.from(section.querySelectorAll('.lookbook-viewer__item'));
    if (!slides.length) return;

    let currentIndex = 0;
    const searchParams = new URLSearchParams(window.location.search);
    const initialSlideParam = searchParams.get('slide');
    const parsedInitialIndex = Number.parseInt(initialSlideParam || '', 10);
    const hasInitialSlide = Number.isFinite(parsedInitialIndex);
    const introTitle = section.querySelector('[data-lookbook-intro-title]');
    const prevBtn = section.querySelector('[data-nav="prev"]');
    const nextBtn = section.querySelector('[data-nav="next"]');
    const track = section.querySelector('.lookbook-viewer__track');
    const isMobile = () => window.innerWidth <= 768;
    const creditsWrap = section.querySelector('.lookbook-viewer__credits-wrap');
    const creditsTrigger = section.querySelector('.lookbook-viewer__credits-trigger');
    const syncMobileCollectionTitleVisibility = () => {
      if (!creditsWrap) return;
      const shouldHideTitle = window.innerWidth <= 768 && creditsWrap.classList.contains('is-open');
      section.classList.toggle('is-credits-open-mobile', shouldHideTitle);
    };
    if (introTitle) {
      setTimeout(() => {
        introTitle.classList.add('is-hidden');
      }, 3000);
    }

    const setIndex = (index, instant = false) => {
      currentIndex = (index + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => {
        slide.classList.toggle('is-active', slideIndex === currentIndex);
      });
      if (track && isMobile()) {
        track.scrollTo({ left: slides[currentIndex].offsetLeft, behavior: instant ? 'instant' : 'smooth' });
      }
    };

    if (hasInitialSlide) {
      setIndex(parsedInitialIndex, true);
    } else {
      setIndex(0);
    }

    // Sync index while swiping the mobile carousel — same rAF pattern as the product gallery
    if (track) {
      let raf = null;
      track.addEventListener(
        'scroll',
        () => {
          if (!isMobile()) return;
          if (raf) return;
          raf = requestAnimationFrame(() => {
            raf = null;
            if (!track.clientWidth) return;
            const index = Math.max(
              0,
              Math.min(slides.length - 1, Math.round(track.scrollLeft / track.clientWidth))
            );
            if (index === currentIndex) return;
            currentIndex = index;
            slides.forEach((slide, i) => slide.classList.toggle('is-active', i === index));
          });
        },
        { passive: true }
      );
    }

    // Button navigation
    if (prevBtn) {
      prevBtn.addEventListener('click', () => setIndex(currentIndex - 1));
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', () => setIndex(currentIndex + 1));
    }

    // Tap the image track on mobile to advance
    section.addEventListener('click', (e) => {
      if (e.target.closest('.lookbook-viewer__credits-wrap') || e.target.closest('a') || e.target.closest('button')) {
        return;
      }
      if (window.innerWidth <= 768) {
        setIndex(currentIndex + 1);
      }
    });

    // Credits logic
    if (creditsWrap) {
      const isDesktopHover = () => window.matchMedia('(hover: hover) and (pointer: fine)').matches;
      const enableGlobalFade = () => document.body.classList.add('fade-global');
      const disableGlobalFadeWhenInactive = () => {
        if (document.getElementById('acci-cart-drawer')?.classList.contains('is-open')) return;
        if (!isDesktopHover()) {
          if (!creditsWrap.classList.contains('is-open')) {
            document.body.classList.remove('fade-global');
          }
          return;
        }
        if (!document.querySelector('.lookbook-viewer__credits-wrap:hover, .lookbook-viewer__credits-wrap:focus-within, .lookbook-viewer__credits-wrap.is-open')) {
          document.body.classList.remove('fade-global');
        }
      };

      creditsWrap.addEventListener('mouseenter', () => {
        if (isDesktopHover()) enableGlobalFade();
      });
      creditsWrap.addEventListener('mouseleave', () => {
        if (isDesktopHover()) disableGlobalFadeWhenInactive();
      });
      creditsWrap.addEventListener('focusin', () => {
        if (isDesktopHover()) enableGlobalFade();
      });
      creditsWrap.addEventListener('focusout', () => {
        if (isDesktopHover()) requestAnimationFrame(disableGlobalFadeWhenInactive);
      });

      if (creditsTrigger) {
        creditsTrigger.addEventListener('click', (e) => {
          if (window.innerWidth <= 768) {
            e.preventDefault();
            const isOpen = creditsWrap.classList.toggle('is-open');
            if (isOpen) {
              enableGlobalFade();
            } else {
              document.body.classList.remove('fade-global');
              disableGlobalFadeWhenInactive();
            }
            syncMobileCollectionTitleVisibility();
          }
        });
      }

      document.addEventListener('click', (e) => {
        if (window.innerWidth <= 768 && creditsWrap.classList.contains('is-open')) {
          if (!creditsWrap.contains(e.target)) {
            creditsWrap.classList.remove('is-open');
            document.body.classList.remove('fade-global');
            disableGlobalFadeWhenInactive();
            syncMobileCollectionTitleVisibility();
          }
        }
      });

      window.addEventListener('resize', syncMobileCollectionTitleVisibility);
      syncMobileCollectionTitleVisibility();
    }
  });
})();
